import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";

import { useProfileQuery } from "../user/profile";
import { QueryKeys } from "../utils";

import request from "@/lib/api/handler";
import { CandidateJobOpening } from "@/types";

export type Opportunity = CandidateJobOpening;

export const useCandidateOpportunities = () => {
  const { profile } = useProfileQuery();
  const { getAccessTokenSilently } = useAuth0();

  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.candidateOpportunities,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled:
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      profile?.userType.includes("Candidate") ||
      profile?.userType.includes("Admin"),
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const resp = await request<Opportunity[]>({
        method: "GET",
        path: "/api/jobopening/self",
        token,
      });

      return resp
        .filter(
          (opportunity) =>
            !opportunity.candidateStatus ||
            (opportunity.candidateStatus.status !== "Identified" &&
              opportunity.candidateStatus.status !== "Initial Outreach"),
        )
        .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    },
  });

  return {
    candidateOpportunitiesLoading: isLoading,
    candidateOpportunities: data ?? null,
    candidateOpportunitiesError: error ?? null,
  };
};
